import { experimental_extendTheme as materialExtendTheme } from "@mui/material/styles";
import { colors, radius } from "./tokens";

export const materialTheme = materialExtendTheme({
	colorSchemes: {
		light: {
			palette: {
				primary: {
					main: colors.primary[500],
					light: colors.primary[300],
					dark: colors.primary[600],
					contrastText: colors.button.primary.text,
				},
				success: {
					main: colors.success[500],
					light: colors.success[300],
					dark: colors.success[700],
					contrastText: "#FFFFFF",
				},
				warning: {
					main: colors.warning[500],
					light: colors.warning[300],
					dark: colors.warning[700],
					contrastText: "#FFFFFF",
				},
				error: {
					main: colors.danger[500],
					light: colors.danger[300],
					dark: colors.danger[700],
					contrastText: "#FFFFFF",
				},
				info: {
					main: colors.info[500],
					light: colors.info[300],
					dark: colors.info[700],
					contrastText: "#FFFFFF",
				},
				background: {
					default: colors.background.body,
					paper: colors.background.surface,
				},
				divider: colors.border.default,
				text: {
					primary: colors.text.primary,
					secondary: colors.text.secondary,
				},
			},
		},
	},
	shape: {
		borderRadius: 0,
	},
	components: {
		MuiTableCell: {
			styleOverrides: {
				head: {
					backgroundColor: colors.table.header,
					fontWeight: 600,
				},
				root: {
					borderColor: colors.table.divider,
				},
			},
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					"&:nth-of-type(even)": {
						backgroundColor: colors.background.level1,
					},
					"&.MuiTableRow-hover:hover": {
						backgroundColor: colors.table.rowHover,
					},
				},
			},
		},
		MuiTableContainer: {
			styleOverrides: {
				root: {
					backgroundColor: colors.background.surface,
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundImage: "none",
				},
			},
		},
	},
});